import { createTableApi } from '~/api/utils/create-table-api';

export const pages = {
  ...createTableApi('/pages')
};
